import {  useState } from 'react';
import {obtenerListaMaestraDatos} from '../data/ListaMaestra';
import { useContext } from "react";
import { AuthContext } from "auth";

import moment from 'moment';
import 'moment/locale/es';

export const useListaMaestra= () => {
    var {user}= useContext(AuthContext);
    const [columnasListaMaestraDatos,setColumnasListaMaestraDatos]=useState([])
    const [listaMaestraDatos,setListaMaestraDatos]=useState([])
   
    const getListaMaestraDatos= async() => {
        console.log('getListaMaestraDatos');
        const respuesta=await obtenerListaMaestraDatos(user.Token);
        console.log(JSON.stringify(respuesta));
        setListaMaestraDatos(respuesta.DatosListaMaestra);
        setColumnasListaMaestraDatos(respuesta.Columnas);
    }
    
    return {
        getListaMaestraDatos,
        columnasListaMaestraDatos,
        listaMaestraDatos

       
       
               
       
    }
}
